module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"tagline":"The Memory Challenge","title":"Hukommelses-IQ","subtitle":"Test arbeidshukommelsen og lær en morsom teknikk som dobler din kreative hukommelse"},"en":{"tagline":"The Memory Challenge","title":"Memory IQ","subtitle":"Test your working memory and learn a fun system that can double your creative memory"}}')
  delete Component.options._Ctor
}
